<table class="table is-bordered is-hoverable" style="margin-bottom: 30px">
  <tr>
    <td style="width: 50%" translationEditableDirective="PROPERTY_CLASS">
      {{ 'PROPERTY_CLASS' | translate }}
    </td>
    <td>
      <div class="is-flex is-flex is-align-items-center">
        <span [translationEditableDirective]="propertyType">{{
          propertyType | translate
        }}</span>
        <button
          [disabled]="isPropertyReportGenerating"
          (click)="onReport.emit(propertyType)"
          class="button is-info is-small"
          style="margin-left: auto"
          translationEditableDirective="REPORT"
        >
          {{ 'REPORT' | translate }}
        </button>
      </div>
    </td>
  </tr>
  <tr *ngFor="let field of fields">
    <td style="width: 50%">
      <span
        [translationEditableDirective]="field.translationKey"
        [translationEditableDirectiveDefault]="field.translationDefaultValue"
        >{{
          field.translationKey
            | translate : { defaultValue: field.translationDefaultValue }
        }}</span
      >
      {{ field.labelAddon }}
    </td>
    <td>{{ field.value === undefined ? '-' : (field.value | translate) }}</td>
  </tr>
</table>
